import { render } from "./CardHeader.vue?vue&type=template&id=d6570590"
import script from "./CardHeader.vue?vue&type=script&lang=js"
export * from "./CardHeader.vue?vue&type=script&lang=js"
script.render = render

export default script